import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { isAssetLoadError, recoverFromAssetLoadError } from '../utils/assetRecovery';
import { FrontErrorView } from './FrontErrorView';

type Props = { children: ReactNode };
type State = { error: Error | null };
export class FrontErrorBoundary extends Component<Props, State> {
  state: State = { error: null };
  static getDerivedStateFromError(error: Error): State { return { error }; }
  private onHistoryChange = () => { if (this.state.error) this.setState({ error: null }); };
  componentDidMount() {
    // React render failures reach this boundary. Background task and extension
    // errors remain visible in the console without unmounting a healthy page.
    window.addEventListener('popstate', this.onHistoryChange);
  }
  componentWillUnmount() {
    window.removeEventListener('popstate', this.onHistoryChange);
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Front v2 render failed:', error, info.componentStack);
    recoverFromAssetLoadError(error);
  }
  render() {
    if (!this.state.error) return this.props.children;
    const assetError = isAssetLoadError(this.state.error);
    return <FrontErrorView status={500} title={assetError ? '页面资源加载失败' : undefined} message={assetError ? '页面脚本暂时无法读取，请点击重新加载以更新资源缓存。' : undefined} onRetry={() => {
      if (!assetError || !recoverFromAssetLoadError(this.state.error, { force: true })) window.location.reload();
    }} onBack={() => window.history.length > 1 ? window.history.back() : window.location.assign('/front-v2/home')} />;
  }
}
